/*
 * Copyright (c) 2025 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { ValidationFunction } from './schema.model';

export const requiredString: ValidationFunction<string | null | undefined> = (value) => {
  if (!value || value.trim() === '') {
    return { required: true };
  }
  return null;
};

export const requiredNumber: ValidationFunction<number | null | undefined> = (value) => {
  if (typeof value !== 'number' || isNaN(value)) {
    return { required: true };
  }
  return null;
};

export const minNumber = (min: number): ValidationFunction<number | null | undefined> => {
  return (value: number | null | undefined) => {
    return value !== null && value !==undefined && value < min ? { min: {min: min} } : null;
  };
}

export const greaterThan = (number: number): ValidationFunction<number | null | undefined> => {
  return (value: number | null | undefined) => {
    return value !== null && value !== undefined && value <= number ? { greaterThan: {greaterThan: number} } : null;
  };
}

export const maxNumber = (max: number): ValidationFunction<number> => {
  return (value: number | null | undefined) => {
    return value !== null && value !== undefined && value > max ? { max: {max: max} } : null;
  };
}

export const maxStringLengthValidator = (max: number): ValidationFunction<string | null> => {
  return (value) => {
    return value && value.length > max ? { maxLength: {max: max} } : null;
  };
}

export const minStringLengthValidator = (min: number): ValidationFunction<string | null> => {
  return (value) => {
    return value && value.length < min ? { minLength: {min: min} } : null;
  };
}

export const minLengthValidator = (min: number): ValidationFunction<any[] | null | undefined> => {
  return (value: any[] | null | undefined ) => {
    return value && value.length < min ? { minLength: min } : null;
  };
}

export const requiredObject: ValidationFunction<any | null | undefined> = (value, label = '') => {
  if (!value) {
    return { [label ? label : 'required']: true };
  }
  return null;
}

